import { get } from './client';
import { buildPath, toJson } from './utils';
import { SPECIAL_HOSTS_PATH } from './constants';
import { IdType } from './types';

export const getSpecialHosts = (id: IdType, options: any): Promise<any> =>
  get(buildPath(SPECIAL_HOSTS_PATH, id), options).then(toJson);
